import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from '../../../../App';
import "react-datepicker/dist/react-datepicker.css";
import { isEndDateGreater, changeDateFormat } from '../../../../Custom/Custom';
import { GlobalLoading, showLoading } from 'react-global-loading';
import titlesData from '../../../../titles.json'
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../.././../assets/Messages.json';
import { generateAnnualIndexReport } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import { useNavigate } from "react-router-dom";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import priceTitle from '../../../../price.json';

const REPORT_YEAR_OPTIONS = [
  { value: 'both', labelEn: 'Financial Year & Calendar Year', labelHi: 'वित्तीय वर्ष एवं कैलेंडर वर्ष' },
  { value: 'financial', labelEn: 'Financial Year', labelHi: 'वित्तीय वर्ष' },
  { value: 'calendar', labelEn: 'Calendar Year', labelHi: 'कैलेंडर वर्ष' },
];

const mapRowToExcelCells = (item) => ([
  item.financial_year,
  item.allGroups,
  item.primary_articles,
  item.fule_power_etc,
  item.manufactured_product,
]);

const getRowMergeCells = (cellCount, row) => {
  const endCol = cellCount === 5 ? 'E' : 'J';
  return `A${row}:${endCol}${row}`;
};

const AnnualIndexPriceReport = () => {
  const [years, setYears] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reportYearType, setReportYearType] = useState("both");
  const token = useContext(MyContextProvider).token;
  const decode_token = getUserClaimsForUi();
  const storedLanguage = localStorage.getItem('language');
  const navigate = useNavigate();
  const [isDivision, setIsDivision] = useState(false);
  const config = getAuthHeaders();
 

  useEffect(() => {
    const getYearList = () => {
      const startYear = 2001;
      const endYear = new Date().getFullYear();
      const yearsArray = [];
      for (let year = endYear; year >= startYear; year--) {
        yearsArray.push(year);
      }
      setYears(yearsArray);
    };
    getYearList();
  }, []);

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleReportYearTypeChange = (event) => {
    setReportYearType(event.target.value);
  };

  const buildExcelConfig = (reportType, financial, calendar, fromYear, toYear) => {
    const singleHeadersHi = ['अवधि', 'समस्त वर्ग', 'प्राथमिक वस्तुएं', 'ईधनशक्ति आदि', 'विनिर्मित उत्पाद्य'];
    const singleHeadersEn = reportType === 'calendar'
      ? ['Calendar Year', 'All groups', 'Primary Articles', 'Fuel Power etc', 'Manufactured product']
      : ['Financial Year', 'All groups', 'Primary Articles', 'Fuel Power etc', 'Manufactured product'];

    if (reportType === 'financial') {
      return {
        cellCount: 5,
        headerHindiColumns: singleHeadersHi,
        headerEnglishColumns: singleHeadersEn,
        excelRowData: financial.map(mapRowToExcelCells),
        fileSuffix: 'Financial',
      };
    }

    if (reportType === 'calendar') {
      return {
        cellCount: 5,
        headerHindiColumns: singleHeadersHi,
        headerEnglishColumns: singleHeadersEn,
        excelRowData: calendar.map(mapRowToExcelCells),
        fileSuffix: 'Calendar',
      };
    }

    const maxLength = Math.max(financial.length, calendar.length);
    const excelRowData = Array.from({ length: maxLength }).map((_, index) => {
      const financialItem = financial[index] || {
        financial_year: '',
        allGroups: '',
        primary_articles: '',
        fule_power_etc: '',
        manufactured_product: '',
      };
      const calendarItem = calendar[index] || {
        financial_year: '',
        allGroups: '',
        primary_articles: '',
        fule_power_etc: '',
        manufactured_product: '',
      };
      return [
        ...mapRowToExcelCells(financialItem),
        ...mapRowToExcelCells(calendarItem),
      ];
    });

    return {
      cellCount: 10,
      headerHindiColumns: [
        ...singleHeadersHi,
        ...singleHeadersHi,
      ],
      headerEnglishColumns: [
        'Financial Year', 'All groups', 'Primary Articles', 'Fuel Power etc', 'Manufactured product',
        'Calendar Year', 'All groups', 'Primary Articles', 'Fuel Power etc', 'Manufactured product',
      ],
      excelRowData,
      fileSuffix: 'Financial_Calendar',
    };
  };

  const handleGenerateExcel = () => {
    if (!startDate || !endDate) {
      toast.error('Please select the date range', messages.COLOR_RED);
      return;
    }
    if (!reportYearType) {
      toast.error('Please select Report Year Type', messages.COLOR_RED);
      return;
    }
    if (!isEndDateGreater(startDate, endDate)) {
      toast.error(messages.DATE_BETWEEN_MESSAGE, messages.COLOR_RED);
      return;
    }

    showLoading(true);

    const payload = {
      fromYear: startDate,
      toYear: endDate,
      reportYearType,
    };

    axios
      .post(`${API_URL}api/price/AnnualIndexPriceReports`, payload, config)
      .then((response) => {
        if (!response.data?.status) {
          toast.error(response.data?.message || 'Data is not found', messages.COLOR_RED);
          showLoading(false);
          return;
        }

        const { financial = [], calendar = [] } = response.data.data || {};
        const excelConfig = buildExcelConfig(reportYearType, financial, calendar, payload.fromYear, payload.toYear);

        if (!excelConfig.excelRowData.length) {
          toast.error('Data is not found', messages.COLOR_RED);
          showLoading(false);
          return;
        }

        const excelObjectData = {
          fileName: `AnnualIndex_${excelConfig.fileSuffix}_${payload.fromYear}_${payload.toYear}`,
          reportType: 'AnnualIndex',
          fileType: 'xls',
          sheetName: 'AnnualIndex',
          firstRowMergeCells: getRowMergeCells(excelConfig.cellCount, 1),
          firstRowExportDate: changeDateFormat(new Date()),
          firstRowCellNumber: excelConfig.cellCount,
          secondRowMergeCells: getRowMergeCells(excelConfig.cellCount, 2),
          secondRowText: `सारीणी -1 (क )   उत्तर प्रदेश के वार्षिक  औसत   थोक भाव सूचकांक -प्रमुख  वर्गवार `,
          thirdRowMergeCells: getRowMergeCells(excelConfig.cellCount, 3),
          thirdRowText: `(आधार   वर्ष 2011-12=100)`,
          fourthRowMergeCells: getRowMergeCells(excelConfig.cellCount, 4),
          fourthRowText: `Table-1 (a) ANNUAL AVERAGE WHOLESALE PRICE INDEX NUMBERS OF U.P. MAJOR GROUPWISE`,
          fifthRowMergeCells: getRowMergeCells(excelConfig.cellCount, 5),
          fifthRowText: `(BASE YEAR 2011-12=100)`,
          fromDate: payload.fromYear,
          toDate: payload.toYear,
          headerHindiColumns: excelConfig.headerHindiColumns,
          headerEnglishColumns: excelConfig.headerEnglishColumns,
          excelRowData: excelConfig.excelRowData,
        };

        generateAnnualIndexReport(excelObjectData);
        showLoading(false);
      })
      .catch((error) => {
        console.error('API Error:', error);
        toast.error(error.response?.data?.message || 'Failed to fetch report data', messages.COLOR_RED);
        showLoading(false);
      });
  };

  return (
    <>
      <GlobalLoading />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.ANNUAL_INDEX_PRICE_REPORT : priceTitle.en.ANNUAL_INDEX_PRICE_REPORT }} />
              </h4>
              <div className="row align-items-center">
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label className="fw-bold h6">
                    {storedLanguage === 'hi' ? 'वर्ष (से)' : 'From Year'}
                  </label>
                  <select
                    id="startDateDropdown"
                    name="start_date"
                    className="form-select"
                    onChange={handleStartDateChange}
                    value={startDate}
                  >
                    <option value="" disabled>Select Year</option>
                    {years &&
                      years.map((ele, index) => (
                        <option key={index} value={ele}>
                          {ele}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label className="fw-bold h6">
                    {storedLanguage === 'hi' ? 'वर्ष (तक)' : 'To Year'}
                  </label>
                  <select
                    id="endDateDropdown"
                    name="end_date"
                    className="form-select"
                    onChange={handleEndDateChange}
                    value={endDate}
                  >
                    <option value="" disabled>Select Year</option>
                    {years &&
                      years.map((ele, index) => (
                        <option key={index} value={ele}>
                          {ele}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 mb-3">
                  <label className="fw-bold h6">
                    {storedLanguage === 'hi' ? 'रिपोर्ट वर्ष प्रकार' : 'Select Report Year'}
                  </label>
                  <select
                    name="reportYearType"
                    className="form-select"
                    onChange={handleReportYearTypeChange}
                    value={reportYearType}
                  >
                    {REPORT_YEAR_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {storedLanguage === 'hi' ? option.labelHi : option.labelEn}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-xl-2 col-lg-4 mb-3">
                  <label className="w-100 d-none d-sm-block">&nbsp;</label>
                  <button onClick={handleGenerateExcel} className="btn btn_orange">Search</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default AnnualIndexPriceReport
